import { useQuery } from "@apollo/client";
import { NavigationBar } from "components/base/base";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import AddProductToStockView from "./AddProductToStockView";
import ChinaStocksProductTableView from "./ChinaStocksProductTableView";
import { FETCH_CHINA_STOCK_PRODUCTS } from "./graphql";

const ChinaStockProducts = () => {
  const { stockId } = useParams();
  const { loading, error, data } = useQuery(FETCH_CHINA_STOCK_PRODUCTS, {
    variables: { stockId },
  });
  const [searchParams] = useSearchParams();
  const ref = useRef();

  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  function tryAddProduct(stock) {
    modal.present({
      title: "Add Product",
      center: true,
      children: <AddProductToStockView hide={modal.hide} stock={stock} />,
    });
  }

  const adminLink = `${process.env.REACT_APP_SERVER_ADMIN_URL}stock/stock/${stockId}/change/`;

  const params = Object.fromEntries(searchParams.entries());
  const products = data.odooStock.products.filter((i) => {
    if (params.productOdooId) {
      return i.odooId === parseInt(params.productOdooId);
    }
    return true;
  });

  const q = params.q;

  return (
    <div className="flex flex-col flex-1 overflow-auto">
      <NavigationBar
        backTo={`./..${q ? `?q=${q}` : ""}`}
        title={data.odooStock.name}
        rightButtons={
          <div className="flex items-center space-x-4">
            <Button onClick={() => tryAddProduct(data.odooStock)}>
              + Add Product
            </Button>

            <a href={adminLink} target="_blank">
              Admin
            </a>

            <Button
              onClick={() => {
                ref.current.download();
              }}
            >
              Download
            </Button>
          </div>
        }
      />
      {data.odooStock.products.length === 0 ? (
        <div className="p-6">No products found in this stock.</div>
      ) : (
        <ChinaStocksProductTableView ref={ref} products={products} />
      )}
    </div>
  );
};

export default ChinaStockProducts;
